<template>
  
    <div id="muestrasSolicitud">
     
   
        <div class="info_cliente">
           
            <p class="client_name"> <span v-if="solicitud.id_sucursal !=null && solicitud.sucursal.name">{{solicitud.sucursal.name}}</span> <span v-else>{{solicitud.cliente.name}}  </span></p>

             <div class="dflx">
            <p class="pnum">No. de Cliente</p> 
            <p class="inp i1">{{solicitud.cliente.numcli}}</p>   
            <p class="prfc">RFC</p>
            <p class="inp i2">{{solicitud.cliente.td_rfc}}</p>  
            <p class="pemail">E-mail</p>
            <p class="inp i2"> {{solicitud.cliente.email}} </p>  
         </div>

         <div class="dflx">
             <p class="pdir">Direccion</p>
               <p class="inp i3"> <span v-if="solicitud.id_sucursal==null">{{solicitud.cliente.address}}</span> <span v-else>{{solicitud.sucursal.address}}</span></p>  
            <p class="pciu">Ciudad</p>
            <p class="inp i2"> <span v-if="solicitud.id_sucursal==null">{{solicitud.cliente.city}}</span> <span v-else>{{solicitud.sucursal.city}}</span></p>  
         </div>

          <div class="dflx">
               <p class="pcol">Colonia</p>
            <p class="inp i2"> <span v-if="solicitud.id_sucursal==null">{{solicitud.cliente.col}}</span> <span v-else>{{solicitud.sucursal.col}}</span> </p>  
             <p class="pcp">C.P.</p>
            <p class="inp i2"> <span v-if="solicitud.id_sucursal==null">{{solicitud.cliente.cp}}</span> <span v-else>{{solicitud.sucursal.cp}}</span>    </p>  
             <p class="ptel">Teléfono</p>
            <p class="inp i2"> <span v-if="solicitud.id_sucursal==null">{{solicitud.cliente.phone}}</span> <span v-else>{{solicitud.sucursal.phone}}</span> </p>  
          </div>
        </div>

       
         <hr class="hrinf">

           <div class="info_cliente">
           
                  
            <p class="client_name">{{solicitud.clave_LAASON}}</p>

           
           
           
             <div class="dflx">
            <p class="pnum">Fecha</p> 
            <p class="inp i1">{{solicitud.fecha}}</p>   
            <p class="prfc">Hora</p>
            <p class="inp i2">{{solicitud.hr}}</p>  
           <!-- <p class="pemail">Forma</p>
            <p class="inp i2"> {{solicitud.forma}}</p>  -->
         </div>

         <!-- <div class="dflx">
             <p class="pdir2">Observaciones</p>
               <p class="inp i4">{{solicitud.muestras}}</p>  
           
         </div> -->

        
        </div>

          <hr class="hrinf">
    

        <div>
            <div class="dflx">
      
         <!--
         <div class="btnfiltro btn1 dflx"> <div class="txtb"> FECHA</div> <img src="../../assets/filtrar.png" alt="icono filtrar"></div>
         <div class="btnfiltro btn2 dflx"> <div class="txtb">ACTIVAS</div> <img src="../../assets/filtrar2.png" alt="icono filtrar"></div>
         <div class="btnfiltro btn2 dflx"> <div class="txtb">CONCLUIDAS</div> <img src="../../assets/filtrar2.png" alt="icono filtrar"></div>
        
    -->

        <!--  <div class="buscador">
            <input v-model="search_value" type="search" id="input-search" class="form-control" :placeholder="'Búsqueda'"  />
            <div class="icon_buscar">
                <img @click="search(search_value)" src="../../assets/Search.png" alt="icono buscar">
            </div>

        </div> -->

           <div  id="navigate-buttons">
                    <div class="dflx">
                        <button @click="prev" id="btn-prev" class="btn-navigate  ">	&#10094;</button>
                        <p class="num-pages"> 1 - 1</p>
                        <button @click="next"  id="btn-next" class="btn-navigate  ">&#10095;</button>
                     </div>
        </div>


        </div>
        

        <div class="tbl_vistaclientes">
            <div class="tbl_header">
                <div class="tblh hfecha">
                  <p>FECHA</p>
                </div>
                 <div class="tblh hclv">
                  <p>CLAVE</p>
                </div>
                 <div class="tblh htipo">
                  <p>TIPO DE MUESTRA</p>
                </div>
                  <div class="tblh htipo">
                  <p>OBSERVACIONES</p>
                </div>
                 <div class="tblh hdtm">
                  <p>DETERMINACIONES</p>
                </div>
                 <div class="tblh hfma">
                  <p>INGRESADA  <br> EN PROCESO</p>
                </div>
                 <div class="tblh hfma itmw">
                  <p>LIBERADA</p>
                </div>
                 <div class="tblh hspv">
                  <p>VALIDADA</p>
                </div>
                <div class="hopt">

                </div>
               
            </div>
        
            <div tbl_content>
                <div v-if="data != 'No se encontraron coincidencias.' && data != 'error'" > <!--  -->
                    <div class="tbl_items" v-for="(item, key) in filteredItems" :key="key">
                        <div  class="tbl_item itfecha">
                               <p @click="muestraCliente(item)">{{convertdate(item.servicio.fecha)}}</p>
                        </div>
                         <div  class="tbl_item itclv">
                               <p @click="muestraCliente(item)">{{item.servicio.clave_LAASON}}</p>
                        </div>
                         <div  class="tbl_item ittipo">
                               <p @click="muestraCliente(item)">{{item.tipo}}</p>
                        </div>
                         <div  class="tbl_item ittipo">
                               <p @click="muestraCliente(item)">{{item.extra.obv}}</p>
                        </div>
                         <div  class="tbl_item itdtm">
                               <p @click="muestraCliente(item)">{{determinaciones(item.resultados)}}</p>
                        </div>
                         <div  class="tbl_item itfma">
                               <p @click="muestraCliente(item)"><span v-if="item.f_analista != null"> 	&#10003;</span>  <span v-else> - </span></p>
                        </div>
                         <div  class="tbl_item itfma">
                               <p @click="muestraCliente(item)"><span v-if="item.f_liberacion != null"> 	&#10003;</span>  <span v-else> - </span></p>
                        </div>
                         <div  class="tbl_item itspv">
                               <p @click="muestraCliente(item)"><span v-if="item.superviso != null">	&#10003;</span>  <span v-else> - </span></p>
                        </div>
                         <div class="dflx" v-if="identity.role !='recepcionista'">
                             <div  @click="muestraCliente(item)" class="tbloptions tbldel">
                            <img src="../../assets/Vector.svg" alt="">
                            <p>VER RESULTADOS</p>
                        </div>
                        <div @click="PDFview(item)" class="tbloptions tbldwl">
                            <img src="../../assets/Download.svg" alt="">
                            <p>DESCARGAR RESULTADOS</p>
                        </div>
                         </div>
                       
                    </div>
                     
                </div>  
                <div v-else>
                    <p class="snr">Aun no hay registros.</p>
                </div> 
            </div>
        </div>

        </div>
       
      
                        <div class="dflx">
                             <p @click="wait()" class="btnRegresar3">Regresar</p>
                        </div>

      
     

       <div v-if="status !=''" class="status_messages">
                            <div v-if="status =='success'" class="msg msg_success">
                                 <p>{{message}}</p>
                            </div>
                            <div  v-if="status =='error'" class="msg msg_error">
                                <p>{{message}}</p>
                            </div>
        </div>
        

      
      

        

    </div>
</template>
<script>


import {mapActions} from 'vuex';
import dayjs from 'dayjs'
export default {
    name: 'muestrasSolicitud',
    components:{

    },
 
   data(){
       return{

           status:'',
           message:'',
           item: '',
           search_value:'',
           currentPage: 1,
           itemsPerPage:   12,


           viewModal:false,
           itemDel:''
           
       }
   },
   created(){
     let item =  this.$store.getters["solserv/getAdded"]
      let data ={
            id:item.id,
            option:'muestras/solicitud'
        }
        this.getInfoByIdMtr(data)
          this.getIdentity()
   },

    computed:{
        solicitud(){
            return this.$store.getters["solserv/getAdded"]
        },
        historyOption(){
            return this.$store.getters["solserv/getHistoryOption"]
        },

        data(){
             return this.$store.getters["muestras/data"]
        },

         identity() {
      return this.$store.getters['admin/getIdentity'];
    },


      
        allItems () {
            let data = this.$store.getters["muestras/data"]
            return Object.keys(data).map(pid => data[pid])
        },
        filteredItems () {
        
             return  this.allItems.slice((this.currentPage - 1) * this.itemsPerPage, this.currentPage * this.itemsPerPage )
        },
        totalPages () {
            let total = Math.ceil(this.allItems.length / this.itemsPerPage)
                if(total < this.currentPage){
                this.currentPage =1
                }
        return total
       },
    },
   
   methods:{
        ...mapActions('main', ['setHistoryOptionMain']),
         ...mapActions('solserv', ['setHistoryOptionSrv']),
         ...mapActions('solserv', ['setAddedSrv']),
         ...mapActions('muestras', ['getInfoByIdMtr']),
         ...mapActions('muestras', ['setAddedMtr']),
         ...mapActions('PDF', ['setAddedPDF']),
           getIdentity: async function (){
          let response =  await this.$store.dispatch("admin/getData");
          return response
      },
        muestraCliente(item){
             if(this.identity.role != 'recepcionista'){
                   this.setAddedMtr(item)
               this.setHistoryOptionSrv('MuestraDetalle')
             }
        },
         showModal: function(id){
             this.itemDel =id;
             this.viewModal=true
         },
         closeModal:function(){
             this.viewModal=false;
             this.itemDel =''
         },
        wait: function(){
            setTimeout(() => this.$router.go(), 200);
        },
        delStatus: function () {
            setTimeout(() => this.delMsgs()
            ,2000);
            setTimeout(() => this.wait()
            ,500);
            
        },
         delStatus2: function () {
            setTimeout(() => this.delMsgs()
            ,2000);
            
        },
        delMsgs: function(){
            this.status=""
            this.message=""
        },
         
         search: async function(value){
            let option = 'muestras';
           
          
            let payload ={
              option : option,
              search: value
            }
            if(value!=""){
                this.$store.dispatch("solserv/searchCli", payload);
            }else{
               this.getAllInfoCli('muestras')
            }
         },
         changeView(option, item){
             this.item=item
             this.setAddedCli(item)
             this.setHistoryOptionCli(option)
         },
        PDFview: function(muestra) {
          if(muestra.superviso =="" || muestra.superviso==null){
              this.message='Esta muestra aún no se ha supervisado'
              this.status='error'
              this.delStatus2()
          }else if(muestra.extra.apar == '' || muestra.extra.apar == null){
               this.message='Faltan campos por llenar. (apariencia, cantidad, presentación, transporte).'
               this.status='error'
               this.delStatus2()
          }else{
            this.setAddedPDF(muestra)
            if(muestra.extra.pdfidioma === 'ingles')this.setHistoryOptionMain('PDFenglishcreate')
            else this.setHistoryOptionMain('PDFcreate')
          }
        },


         // botones de paginacion.
         next () {
          
          if ( this.currentPage < this.totalPages) {
            this.currentPage++
          }
        },
        prev () {
          if (this.currentPage > 1) {
            this.currentPage--
          }
        },

          convertdate(fecha){
            let day = dayjs(fecha).format('DD/MM/YYYY')
            return day
        },
        determinaciones(resultados){
            let str =''
            if(resultados ==''){
                return str
            }
            for(var i=0; i< resultados.length; i++){
                if(i == 0){
                    str = str + resultados[i].pabr
                }else{
                    str = str + ',' + resultados[i].pabr
                }
            }

            return str
        },

   }

    
 
}
</script>

<style scoped>

 p.snr{
         width: 53.8VW; 
        height: 2.2916666666666665VW;
        text-align: center;
        padding-top: .5vw;
        background: #F8F8F8;
        color: #868686;
             font-size: 0.7375VW;
    }


  hr.hrinf{
    width: 57.969vw; 
    border: 0.5px solid #D3D3D3;
    margin-left: -1vw;
    margin-bottom: 2vw;
    margin-top: 1vw;
  }


    #muestrasSolicitud{
        margin-top: 5.288020833333333VW;
        margin-left: 0.9375VW ;
        }

        .info_cliente p{
            font-size: 0.677vw;
            padding-top: 0.148vw ;
            color: #868686;
        }

         p.texthrd{
            font-size: 0.877vw;
            padding-top: 0.148vw ;
            color: #868686;
            font-weight: 700;

        }

        p.client_name{
            font-size: 1.615vw;
            font-weight: 400;
            padding-top: 0vw;
        }

   p.inp{
        border: 0.052083333333333336VW solid #D3D3D3 ;
       color: #868686;
       font-weight: 700;
       height: 1.354vw;
       padding-left: 0.573vw;
   }
   p.i2{
       width: 12.813vw;
   }
   p.i1{
       width: 11.094vw;
   }

    p.i3{
        width: 31.927vw;
    }   
p.i4{
         width: 49.8vw;
    }
    p.pnum{
        width: 4.792vw;
        margin-right: 1.042vw;
    }
    p.pdir{
        width: 3.229vw;
        margin-right: 0.885vw;
    }
    p.pdir2{
        width: 4.94vw;
        margin-right: 0.885vw;
    }

    p.pcol{
        width: 2.604vw;
        margin-right: 1.510vw;
    }

    p.prfc, p.pcp {
        margin-left: 3.958vw;
        margin-right:1.042vw ;
        width: 1.302vw;
    }

     p.pemail{
        margin-left:2.865vw;
        margin-right:1.719vw ;
        width: 2.135vw;
    }

     p.pciu{
        margin-left:2.865vw;
        margin-right:1.458vw ;
        width: 2.396vw;
    }
     p.ptel{
        margin-left:2.865vw;
        margin-right:0.833vw;
        width: 3.021vw;
    }




   .btnfiltro{
        cursor:pointer;
        width: 7.240vw;
        height: 1.823vw;
        border: 0px;
        margin-right: 0.072vw;
        font-size: 0.625vw;
        font-weight: 700;
        color:white;
        text-align: left;
        padding-top: .4vw;
        padding-left: 0.990vw;
    }
   .btnfiltro .txtb{
        width: 4.6vw;
       
    }
    .btnfiltro img{
        width: 0.885vw;
        height: 0.938vw;
    }
    .btn1{
        background: #009084;
    }
    .btn2{
         background: #007E94;
    }

    .buscador {
    display: flex;
    margin-left: 7.5375VW;
    }
   .buscador input{
     border-radius: 0vw;
     border: 0.052083333333333336VW solid var(--color-6);
     width: 11.250000000000002VW;
     height: 1.8192708333333332VW; 
     padding-left: 1.8vw;
     font-size: 0.6770833333333334VW;
     color: var(--color-4) !important;
     border-right: 0vw;
   }.buscador input:target{
       background: var(--color-1);
   }

   input:-internal-autofill-selected {
       background: white !important;
   }

   .icon_buscar{
        border-radius: 0vw;
        border: 0.052083333333333336VW solid var(--color-6);
        width: 2.5VW;
        height: 1.8192708333333332VW;
        padding-left: 0.8vw;
        font-size: 0.6770833333333334VW;
        color: var(--color-4) !important;
    border-left: 0vw;
   }.icon_buscar img{
       width: 0.9895833333333333VW;
       height: 0.9895833333333333VW;
       margin-top: 0.4411458333333334VW;
   }




    

    .tbl_vistaclientes{
            width: 68.3VW;
        margin-top: 1.5625VW;
    }

    .tbl_header{
        display: flex;
        background:var(--color-2);
    }.tblh, .tbl_item{
        height: 2.2916666666666665VW;
    }.tblh p{
        color:var(--color-5);
        font-weight: 700;
        font-size: 0.9375VW;
        padding-top: 0.46875VW;
        /*padding-left: 1.4583333333333333VW;*/
        text-align: center;
    }

    .tbl_items{
        display: flex;
        
    }.tbl_item{
         padding-top: 0.36875VW;
         padding-left: .9VW;
         background: #F8F8F8;
         border: 1px solid white;

    }.tbl_item p{
        font-size:0.7291666666666666VW;
        color: #868686;
        margin-bottom: 0vw;
     
    }

    .hopt{
      width: 12.333vw;
       border-right: 0.052083333333333336VW solid var(--color-5);
       background: white;
    }

    .tbloptions{
        width: 5.427083333333334VW;
        display: flex;
        background: #007E94;
        border: 1px solid white;
        padding: 0.1vw 0.5vw;
        text-align: center;
        cursor: pointer;
    }
    .tbloptions p {
        width: 3vw;
        font-size: 0.53vw;
        text-align: left;
        color: white;
        margin: auto;
        margin-left: 0.5vw;
    }
    .tbldwl img{
        width: 0.729vw;
        height: 0.885vw;
        margin-top: 0.6vw;
    }
    .tbldel img{
        width: 0.729vw;
        height: 0.573vw;
        margin-top: 0.8vw;
    }

.itmw p{
    
    padding-top: 0.7vw !important;
    font-size: .8vw !important;

}

    .hfecha{
        width: 5.156vw;
        border-right: 0.052083333333333336VW solid var(--color-5);
    }
    .itfecha{
        width: 5.156vw;
         overflow: auto;
          cursor: pointer;
    }


    .hclv{
        width: 5.156vw;
        border-right: 0.052083333333333336VW solid var(--color-5);
    }
    .hclv p{
        padding-top: .7vw;
        font-size: 0.625vw;
    }
    .itclv{
        width: 5.156vw;
         overflow: auto;
         cursor: pointer;
    }
    .itclv p{
      color:  #868686;
      font-weight: 700;
    }

    .htipo{
        width: 8.125vw;
        border-right: 0.052083333333333336VW solid var(--color-5);
    }
     .htipo p{
        padding-top: .7vw;
        font-size: 0.625vw;
    }
    .ittipo{
        width: 8.125vw;
         overflow: auto;
          cursor: pointer;
    }
    
     .hdtm{
           width: 10.25vw;
        border-right: 0.052083333333333336VW solid var(--color-5);
    }
   
    .itdtm{
           width: 10.25vw;
         overflow: auto;
          cursor: pointer;
    }


     .hfma{
        width: 5.469vw;
        border-right: 0.052083333333333336VW solid var(--color-5);
    }

     .hfma p{
         padding-top: .3vw;
        font-size: 0.625vw;
        
    }
   
    .itfma{
        width: 5.469vw;
         overflow: auto;
         padding-left: 0vw;
          cursor: pointer;
    }.itfma p{
        text-align: center;
        
    }

     .hspv{
        width: 8.229vw;
        border-right: 0.052083333333333336VW solid var(--color-5);
    }

   
    .itspv{
        width: 8.229vw;
         overflow: auto;
         padding-left: 0vw;
          cursor: pointer;
    }.itspv p{
       text-align: center;
    }
    
    

     

    

  /** estilos scroll bar */
    .tbl_item::-webkit-scrollbar {
    -webkit-appearance: none;
    }

    .tbl_item::-webkit-scrollbar:vertical {
        width:0.3645833333333333VW;
    }

    .tbl_item::-webkit-scrollbar-button:increment,.tbl_item::-webkit-scrollbar-button {
        display: none;
    } 

    .tbl_item::-webkit-scrollbar:horizontal {
        height: 0.3645833333333333VW;
    }

    .tbl_item::-webkit-scrollbar-thumb {
        background-color: #797979;
        /*border-radius: 1.0416666666666665VW;*/
        border: 0.10416666666666667VW solid #f1f2f3;
    }

    .tbl_item::-webkit-scrollbar-track {
        border-radius: 0.3645833333333333VW;  
    }

</style>
